import React from "react";
import "./RoadmapItem.css";

const RoadmapItem = ({
  label,
  description,
  position = "right", // 'right' or 'left'
  leftPosition = "78%", // default position
  circleMargin = 30, // margin for the circle
  lineMargin = 30, // margin for the line
}) => {
  const isLeft = position === "left";

  return (
    <div
      className="roadmap-content-item"
      style={{
        left: leftPosition,
        flexDirection: isLeft ? "row-reverse" : "row",
      }}
    >
      <label>{label}</label>
      <div
        className="roadmap-content-item-circle"
        style={{
          marginLeft: isLeft ? 0 : circleMargin,
          marginRight: isLeft ? circleMargin : 0,
        }}
      />
      <div
        className="roadmap-content-item-line"
        style={{
          marginLeft: isLeft ? lineMargin : 0,
          marginRight: isLeft ? 0 : lineMargin,
        }}
      />
      <p style={{ textAlign: isLeft ? "right" : "left" }}>{description}</p>
    </div>
  );
};

export default RoadmapItem;
